// extracted by mini-css-extract-plugin
export default {"button":"button_button__8T9m-","buttonText":"button_buttonText__aN-wS","add":"button_add__MrB9Q","outline":"button_outline__Fn2hX","icon":"button_icon__uS1Xi"};